import React, { useState } from "react";
import { useForm } from "react-hook-form";

import { Spinner } from "react-bootstrap";
import { EyeSlash, Eye } from "iconsax-react";

import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import { ROUTE_FORGET_PASSWORD } from "../../../../routes";

import InputComponent from "../../../public/form/input";
import ButtonComponent from "../../../public/button";
import { LinkButton } from "../userChangeInfComponent";
import GoBackButtonComponent from "../../../public/goBackButton";

import {
  EyesContainer,
  FormContainer,
  FormRowInputContainer,
  InfoContainer,
} from "./styledUserChangePassComponent";

function UserChangePassComponent({ handleChangePassword, loading }) {
  const [isShowCurrentPass, setIsShowCurrentPass] = useState(false);
  const [isShowNewPass, setIsShowNewPass] = useState(false);
  const [isShowConfirmPass, setIsShowConfirmPass] = useState(false);

  const inputList = {
    old_password: {
      title: "رمز عبور فعلی",
      changeType: () => setIsShowCurrentPass((prevState) => !prevState),
      value: isShowCurrentPass,
      showLinkButton: true,
    },
    new_password: {
      title: "رمز عبور جدید",
      changeType: () => setIsShowNewPass((prevState) => !prevState),
      value: isShowNewPass,
    },
    password_confirm: {
      title: "تکرار رمز عبور جدید",
      changeType: () => setIsShowConfirmPass((prevState) => !prevState),
      value: isShowConfirmPass,
    },
  };

  const handleChangeTypeInput = (inputType) => {
    inputList[inputType].changeType();
  };

  const renderIcon = (value, name) => {
    if (value)
      return (
        <Eye className="mx-2" onClick={() => handleChangeTypeInput(name)} />
      );
    return (
      <EyeSlash className="mx-2" onClick={() => handleChangeTypeInput(name)} />
    );
  };

  const schema = yup.object().shape({
    old_password: yup.string().required("پر بودن این فیلد الزامی است."),
    new_password: yup.string().required("پر بودن این فیلد الزامی است."),
    password_confirm: yup.string().required("پر بودن این فیلد الزامی است."),
  });

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({ resolver: yupResolver(schema) });

  return (
    <InfoContainer>
      <GoBackButtonComponent />
      <FormContainer
        onSubmit={handleSubmit(handleChangePassword)}
        className="row align-items-center"
      >
        {Object.keys(inputList).map((item, index) => (
          <FormRowInputContainer
            key={index}
            className="justify-content-center mt-4"
          >
            <InputComponent
              title={inputList[item].title}
              type={inputList[item].value ? "text" : "password"}
              dir="ltr"
              name={item}
              withBoxShadow
              register={register(item.toString())}
              error={errors?.[item]?.message}
              autoComplete="off"
              containerClass="input"
              iconStart={
                <EyesContainer>
                  {renderIcon(inputList[item].value, item)}
                </EyesContainer>
              }
            />
            {inputList[item].showLinkButton && (
              <LinkButton
                title="فراموشی رمز عبور"
                to={ROUTE_FORGET_PASSWORD}
                className="align-self-start"
              />
            )}
          </FormRowInputContainer>
        ))}

        <FormRowInputContainer className="justify-content-center mt-5">
          <ButtonComponent className="col-12" type="submit">
            {loading ? (
              <Spinner
                as="span"
                animation="border"
                role="status"
                aria-hidden="true"
              />
            ) : (
              "ثبت رمز جدید"
            )}
          </ButtonComponent>
        </FormRowInputContainer>
      </FormContainer>
    </InfoContainer>
  );
}

export default UserChangePassComponent;
